import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import logo from "../assets/ShubhPaisa.svg"; 

const AdminNavbar = () => {
  const { logout } = useContext(AuthContext);

  return (
    <nav
      className="navbar px-4"
      style={{
        height: "56px",
        backgroundColor: "#fff", // white navbar
        borderBottom: "1px solid #ddd",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingRight: "20px",
        paddingLeft: "20px",
      }}
    >
      {/* Logo */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={logo}
          alt="Logo"
          style={{ height: "40px", marginRight: "10px" }}
        />
        
      </div>

      {/* Logout Button */}
      <button
        className="btn btn-outline-secondary btn-sm"
        onClick={logout}
      >
        Logout
      </button>
    </nav>
  );
};

export default AdminNavbar;
